<template>
  <div>
    <div class="items">
      <!--first row-->
      <div class="row">
        <div class="col-xs-12 col-md-6 col-lg-4">
          <div class="overlay"></div>
           <router-link to="/computers">play</router-link>
          <img src="@/assets/img/img6.jpg" />
        </div>
        <div class="col-xs-12 col-md-6 col-lg-4">
          <div class="overlay"></div>
         <router-link to="/math">play</router-link>
          <img src="@/assets/img/img7.jpg" />
        </div>
        <div class="col-xs-12 col-md-6 col-lg-4">
          <div class="overlay"></div>
          <router-link to="/sports">play</router-link>
          <img src="@/assets/img/img8.jpg" />
        </div>
      </div>

      <!--first row-->
      <!--second row-->
      <div class="row">
        <div class="col-xs-12 col-md-6 col-lg-4">
          <div class="overlay"></div>
         <router-link to="/animals" >play</router-link>
          <img src="@/assets/img/img3.jpg" />
        </div>
        <div class="col-xs-12 col-md-6 col-lg-4">
          <div class="overlay"></div>
        <router-link to="/videoG">play</router-link>
          <img src="@/assets/img/img4.jpg" />
        </div>
        <div class="col-xs-12 col-md-6 col-lg-4">
          <div class="overlay"></div>
         <router-link to="/nature">play</router-link>
          <img src="@/assets/img/img5.jpg" />
        </div>
      </div>
      <!--second row-->
      <!--3 row-->
      <div class="row">
        <div class="col-xs-12 col-md-6 col-lg-4">
          <div class="overlay"></div>
          <router-link to="/books">play</router-link>
          <img src="@/assets/img/img.jpg" />
        </div>
        <div class="col-xs-12 col-md-6 col-lg-4">
          <div class="overlay"></div>
         <router-link to="/film">play</router-link>
          <img src="@/assets/img/img1.jpg" />
        </div>
        <div class="col-xs-12 col-md-6 col-lg-4">
          <div class="overlay"></div>
         <router-link to="/music">play</router-link>
          <img src="@/assets/img/img2.jpg" />
        </div>
      </div>
      <!--3 row-->
      <!--4 row-->
      <div class="row">
        <div class="col-xs-12 col-md-6 col-lg-4">
          <div class="overlay"></div>
           <router-link to="/history">play</router-link>
          <img src="@/assets/img/img9.jpg" />
        </div>
        <div class="col-xs-12 col-md-6 col-lg-4">
          <div class="overlay"></div>
         <router-link to="/geography">play</router-link>
          <img src="@/assets/img/img10.jpg" />
        </div>
        <div class="col-xs-12 col-md-6 col-lg-4">
          <div class="overlay"></div>
          <router-link to="/art">play</router-link>
          <img src="@/assets/img/img11.jpg" />
        </div>
      </div>
      <!--4 row-->
      <!--5 row-->
      <div class="row">
        <div class="col-xs-12 col-md-6 col-lg-4">
          <div class="overlay"></div>
          <router-link to="/politics">play</router-link>
          <img src="@/assets/img/img15.jpg" />
        </div>
        <div class="col-xs-12 col-md-6 col-lg-4">
        <router-link to="/cartoon">play</router-link>
          <img src="@/assets/img/img13.jpg" />
        </div>
        <div class="col-xs-12 col-md-6 col-lg-4">
          <div class="overlay"></div>
        <router-link to="/vehiles">play</router-link>
          <img src="@/assets/img/img14.jpg" />
        </div>
      </div>
      <!--5 row-->
    </div>
  </div>
</template>

<script>
export default {
  name: "items",
  mounted() {
    // MY PORTFOLIO
    $(".items  img").each(function() {
      $(this).hover(function() {
        $(this)
          .prevAll()
          .show();
      });
    });

    $(".items .overlay").mouseleave(function() {
      $(this).hide();
      $(this)
        .next(".items  a")
        .hide();
    });
  }
};
</script>
